// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class GoogleMap extends WebComponent {
  didMount() {
    const {
      lat,
      lng
    } = this.props;

    const position = {lat: parseFloat(lat), lng: parseFloat(lng)};

    const map = new google.maps.Map(this.element, {
      center: position,
      zoom: 12,
      zoomControl: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles:            [
        {
          'featureType': 'administrative',
          'elementType': 'labels',
          'stylers':     [
            {
              'visibility': 'on',
            },
            {
              'gamma': '1.82',
            },
          ],
        },
        {
          'featureType': 'administrative',
          'elementType': 'labels.text.fill',
          'stylers':     [
            {
              'visibility': 'on',
            },
            {
              'gamma': '1.96',
            },
            {
              'lightness': '-9',
            },
          ],
        },
        {
          'featureType': 'administrative',
          'elementType': 'labels.text.stroke',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers':     [
            {
              'visibility': 'on',
            },
            {
              'lightness': '25',
            },
            {
              'gamma': '1.00',
            },
            {
              'saturation': '-100',
            },
          ],
        },
        {
          'featureType': 'poi.business',
          'elementType': 'all',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'poi.park',
          'elementType': 'all',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road',
          'elementType': 'labels.icon',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry',
          'stylers':     [
            {
              'hue': '#ffaa00',
            },
            {
              'saturation': '-43',
            },
            {
              'visibility': 'on',
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'road.highway',
          'elementType': 'labels',
          'stylers':     [
            {
              'visibility': 'simplified',
            },
            {
              'hue': '#ffaa00',
            },
            {
              'saturation': '-70',
            },
          ],
        },
        {
          'featureType': 'road.highway.controlled_access',
          'elementType': 'labels',
          'stylers':     [
            {
              'visibility': 'on',
            },
          ],
        },
        {
          'featureType': 'road.arterial',
          'elementType': 'all',
          'stylers':     [
            {
              'visibility': 'on',
            },
            {
              'saturation': '-100',
            },
            {
              'lightness': '30',
            },
          ],
        },
        {
          'featureType': 'road.local',
          'elementType': 'all',
          'stylers':     [
            {
              'saturation': '-100',
            },
            {
              'lightness': '40',
            },
            {
              'visibility': 'off',
            },
          ],
        },
        {
          'featureType': 'transit.station.airport',
          'elementType': 'geometry.fill',
          'stylers':     [
            {
              'visibility': 'on',
            },
            {
              'gamma': '0.80',
            },
          ],
        },
        {
          'featureType': 'water',
          'elementType': 'all',
          'stylers':     [
            {
              'visibility': 'off',
            },
          ],
        },
      ],
    });

    const icon = {
      url: '/img/u/map-marker.png',
      size: new google.maps.Size(54, 63),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(27, 60)
    };

    const marker = new google.maps.Marker({position: position, icon: icon, map: map});
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMap.js